
































































import {
  defineComponent,
  ref,
  computed,
  PropType,
} from '@vue/composition-api';
import { Tabs, TabItem as Tab } from '@hb/coffee';
import type { ChannelContractInfo } from '../type';
import { getContractIframeUrl, formatContractName } from '../utils';

export default defineComponent({
  name: 'ChannelContractTabs',
  components: {
    Tabs,
    Tab,
  },
  props: {
    /** 渠道列表 */
    channelList: {
      type: Array as PropType<ChannelContractInfo[]>,
      required: true,
      default: () => [],
    },
    /** 当只有一家渠道时，是否隐藏渠道 Tabs 区域 */
    hideChannelTabsWhenSingle: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'change-channel',
    'change-contract',
  ],
  setup(props, { emit }) {
    /** 当前选中渠道索引 */
    const activeChannelIndex = ref(0);
    /** 当前选中协议索引 */
    const activeContractIndex = ref(0);

    /** 当前选中的渠道 */
    const currentChannel = computed(() => props.channelList[activeChannelIndex.value] || {
      productId: '',
      productName: '',
      productIcon: '',
      contractList: [],
      isSelected: false,
    });

    /** 当前协议 iframe URL */
    const currentIframeUrl = computed(() => {
      const contract = currentChannel.value.contractList[activeContractIndex.value];
      if (!contract) {
        return '';
      }
      return getContractIframeUrl(contract.url, contract.type);
    });

    /** 切换渠道 */
    const handleChangeChannel = (index: number) => {
      activeChannelIndex.value = index;
      activeContractIndex.value = 0;

      emit('change-channel', {
        channel: currentChannel.value,
        index,
      });
    };

    /** 切换协议 */
    const handleChangeContract = (index: number) => {
      activeContractIndex.value = index;

      emit('change-contract', {
        channel: currentChannel.value,
        contract: currentChannel.value.contractList[index],
        index,
      });
    };

    return {
      activeChannelIndex,
      activeContractIndex,
      currentChannel,
      currentIframeUrl,
      handleChangeChannel,
      handleChangeContract,
      formatContractName,
    };
  },
});
